import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.labListing || initialState;

export const selectlabs = createSelector([selectDomain], (state) => state.labs);

export const selectDownloadStatus = createSelector(
  [selectDomain],
  (state) => state.downloadInProgress
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);